import { MapfreCardComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule  } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent],
  selector: 'app-faq',
  templateUrl: './faq.component.html',
})
export class FaqComponent  {
 
}
